import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useMessageService from '../../services/i18n/useMessageService';
import NavigationTabs from '../../constants/NavigationTabs';
import { AuthenticatedPaths } from '../../constants/Paths';

const propTypes = {
    children: PropTypes.node,
    selectedTab: PropTypes.oneOf([
        NavigationTabs.HOME,
        NavigationTabs.GENERAL,
        NavigationTabs.EMAILS,
        NavigationTabs.CHANGE_PASSWORD,
    ]),
};

const MyAccountLayoutDesktop = ({ children, selectedTab }) => {
    const [
        [
            myAccountLabel = 'My Account',
            generalLabel = 'General',
            emailsLabel = 'Emails',
            changePasswordLabel = 'Change Password',
        ],
    ] = useMessageService([
        'my_account.my_account',
        'my_account.general',
        'my_account.emails',
        'my_account.change_password',
    ]);

    const pageTitleCSS = css`
        font-size: 2rem;
        color: #303030;
        padding-bottom: 3.333rem;
        text-align: center;
        font-weight: bold;
    `;

    const contentCSS = css`
        background-color: #ffffff;
        padding: 0;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);
        border-radius: 8px;
        margin: auto;
        display: flex;
        flex-direction: row;
    `;

    const Tab = ({ tab, path, label }) => {
        return (
            <li
                css={css`
                    margin-bottom: 1.333rem;
                    outline: none;
                `}
            >
                <Link
                    css={css`
                        color: ${selectedTab === tab ? '#f8972b' : '#303030'};
                        font-weight: ${selectedTab === tab ? 'bold' : undefined};
                        text-decoration: none;
                        &:hover,
                        &:focus {
                            color: #f8972b;
                            outline: none;
                        }
                    `}
                    to={path}
                >
                    {label}
                </Link>
            </li>
        );
    };

    return (
        <div
            css={css`
                width: 58.333rem;
                margin: 8.333rem auto 0;
                padding-bottom: 3.333rem;
                font-size: 1.167rem;
            `}
        >
            <div css={pageTitleCSS}>{myAccountLabel}</div>
            <div css={contentCSS}>
                <div
                    css={css`
                        width: 16.667rem;
                        border-right: 1px solid #d9d9d9;
                        box-sizing: border-box;
                    `}
                >
                    <ul
                        css={css`
                            padding: 3.333rem 1.333rem 3.333rem 3.333rem;
                            list-style: none;
                            margin: 0;
                        `}
                    >
                        <Tab
                            path={AuthenticatedPaths.MY_ACCOUNT}
                            label={generalLabel}
                            tab={NavigationTabs.GENERAL}
                        />
                        <Tab
                            path={AuthenticatedPaths.EMAILS}
                            label={emailsLabel}
                            tab={NavigationTabs.EMAILS}
                        />
                        <Tab
                            path={AuthenticatedPaths.CHANGE_PASSWORD}
                            label={changePasswordLabel}
                            tab={NavigationTabs.CHANGE_PASSWORD}
                        />
                    </ul>
                </div>
                <div
                    css={css`
                        width: 41.667rem;
                        padding: 3.333rem;
                        box-sizing: border-box;
                    `}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

MyAccountLayoutDesktop.propTypes = propTypes;

export default MyAccountLayoutDesktop;
